import axios from "../axios";
import { IExcelSensorExportParams, IWaveVoicePrintExportParams } from "./excel.types";

/**
 * 下载加速度时域Excel
 */
export function excelWareDownload(params: { mappingId: string, time: string }) {
    return axios({
        responseType: 'blob',
        method: 'get',
        url: '/excel/ware/download',
        params,
    })
}

/**
 * 导出数据
 */
export function excelWareExport(params: {
    waveId?: number,
    mappingId: number
}) {
    return axios({
        responseType: 'blob',
        method: 'get',
        url: '/excel/ware/export',
        params,
        rawResponse: true,
    })
}

/**
 * 导出数据
 */
export function excelDataExport(params: {
    mappingId: number,
    beginDate: string,
    endDate: string,
}) {
    return axios({
        responseType: 'blob',
        method: 'get',
        url: '/excel/data/export',
        params,
        rawResponse: true,
        timeout: 1000 * 60 * 30,
    })
}

/**
 * 传感器导出 
 */
export function excelSensorExport(params: IExcelSensorExportParams) {
    return axios({
        responseType: 'blob',
        method: 'get',
        url: '/excel/ware/export/sensor',
        params,
        rawResponse: true,
    })
}

/**
 * 声纹导出 
 */
export function waveVoicePrintExport(params: IWaveVoicePrintExportParams) {
    return axios({
        responseType: 'blob',
        method: 'get',
        url: '/excel/waveVoicePrint/export',
        params,
        rawResponse: true,
    })
}
